import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/AnnualReportsPage.css";

const reports = [
  {
    year: 2026,
    title: "ANNUAL REPORT 2026",
    image: "wp-content/uploads/2026/2026-annual.png",
    link: "wp-content/uploads/2026/annualreport2026.pdf",
  },
  {
    year: 2024,
    title: "ANNUAL REPORT 2024",
    image: "wp-content/uploads/2024/13/2024-annual.png",
    link: "wp-content/uploads/2024/13/Annual_Report_2024.pdf",
  },
  {
    year: 2023,
    title: "ANNUAL REPORT 2023",
    image:
      "wp-content/uploads/2024/06/annual_2023-1-250x376.png",
    link: "wp-content/uploads/2024/06/Annual_Report_2023.pdf",
  },
  {
    year: 2022,
    title: "ANNUAL REPORT 2022",
    image:
      "wp-content/uploads/2023/04/cdl-book-2022-250x376.png",
    link: "wp-content/uploads/2022/WE/Annual_Report_2022.pdf",
  },
  {
    year: 2021,
    title: "ANNUAL REPORT 2021",
    image: "wp-content/uploads/2022/06/cdl-book-2.png",
    link: "wp-content/uploads/2022/06/Annual_Report_2021.pdf",
  },
  {
    year: 2020,
    title: "ANNUAL REPORT 2020",
    image: "wp-content/uploads/2021/04/cdl-book.png",
    link: "wp-content/uploads/2021/04/Dockyard_AR_2020.pdf",
  },
  {
    year: 2019,
    title: "ANNUAL REPORT 2019",
    image: "wp-content/uploads/2020/08/2019-cover.png",
    link: "wp-content/uploads/2020/08/Dockyard_AR_2019.pdf",
  },
  {
    year: 2018,
    title: "ANNUAL REPORT 2018",
    image: "wp-content/uploads/2019/04/23.png",
    link: "wp-content/uploads/2019/04/AR-2018.pdf",
  },
  {
    year: 2017,
    title: "ANNUAL REPORT 2017",
    image: "wp-content/uploads/2018/09/new-report1-2018.png",
    link: "wp-content/uploads/2018/09/Colombo_Dockyard_PLC_Annual_Report_2017.pdf",
  },
  {
    year: 2016,
    title: "ANNUAL REPORT 2016",
    image:
      "wp-content/uploads/2017/05/annual-report-2016.png",
    link: "wp-content/uploads/2017/05/Annual-Report-2016.pdf",
  },
  {
    year: 2015,
    title: "ANNUAL REPORT 2015",
    image:
      "wp-content/uploads/2016/02/annual-report-2015.png",
    link: "wp-content/uploads/2016/07/Colombo%20Dockyard%20AR_2015.pdf",
  },
  {
    year: 2014,
    title: "ANNUAL REPORT 2014",
    image:
      "wp-content/uploads/2016/02/annual-report-2014-cover-1.png",
    link: "wp-content/uploads/2016/02/Colombo-Dockyard-Annual-Report-2014.pdf",
  },
  {
    year: 2013,
    title: "ANNUAL REPORT 2013",
    image:
      "wp-content/uploads/2016/02/annual-report-2013-cover.png",
    link: "wp-content/uploads/2016/02/Colombo-Dockyard-Annual-Report-2013_Final-1.pdf",
  },
  {
    year: 2012,
    title: "ANNUAL REPORT 2012",
    image:
      "wp-content/uploads/2016/02/annual-report-2012-cover.png",
    link: "wp-content/uploads/2016/02/AR_2012.pdf",
  },
  {
    year: 2011,
    title: "ANNUAL REPORT 2011",
    image:
      "wp-content/uploads/2016/02/annual-report-2011-cover-1.png",
    link: "wp-content/uploads/2016/02/Colombo-Dockyard-Annual-Report-2011.pdf",
  },
  {
    year: 2010,
    title: "ANNUAL REPORT 2010",
    image:
      "wp-content/uploads/2016/02/annual-report-2010-cover.png",
    link: "wp-content/uploads/2016/02/AR_2010.pdf",
  },
  {
    year: 2009,
    title: "ANNUAL REPORT 2009",
    image:
      "wp-content/uploads/2016/02/annual-report-2009-cover.png",
    link: "wp-content/uploads/2016/02/AR_2009.pdf",
  },
];

const ReportCard = ({ report }) => {
  return (
    <div className="report-item">
      <h5 className="report-title">{report.title}</h5>
      <a
        href={report.link}
        target="_blank"
        rel="noopener noreferrer"
        className="report-image-link"
      >
        <img src={report.image} alt={report.title} className="report-cover" />
      </a>
    </div>
  );
};

const AnnualReportsPage = () => {
  return (
    <>
      <Header />
      <main className="annual-reports-main">
        <div className="breadcrumb-container">
          <div className="container">
            <nav className="breadcrumb">
              <a href="/">Home</a>
              <span className="separator">&gt;</span>
              <span className="current">Annual Reports</span>
            </nav>
          </div>
        </div>

        <section className="reports-section">
          <div className="container">
            <h1 className="main-title">ANNUAL REPORTS</h1>
            <div className="reports-grid">
              {reports.map((report, index) => (
                <ReportCard key={index} report={report} />
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default AnnualReportsPage;
